import React, { useEffect } from "react";
import OktaSignInWidget from "./OktaSignInWidget";
import { useOktaAuth } from "@okta/okta-react";
import Protected from "./Protected";
import BasicLayout from "./layout/BasicLayout";
import { Container } from "@mui/material";
import { Route, Routes } from "react-router-dom";
import CreditPage from "./pages/CreditPage";
import { useSelector, useDispatch } from "react-redux";
import { UserRole } from "./utils/consts";
import UserMaintenancePage from "./pages/ManageUserPage";
import ServicerMaintenancePage from "./pages/ManageServicerPage";
import api from "./api/api";

import { userLogout } from "./features/userSlice";

const OktaLogin = ({ config }) => {
  const { userRole } = useSelector((state) => state.user);
  const { oktaAuth, authState } = useOktaAuth();
  const dispatch = useDispatch();

  const onSuccess = (tokens) => {
    oktaAuth.handleLoginRedirect(tokens);
  };

  const onError = (err) => {
    console.log("Sign in error:", err);
  };

  const closeOktaSession = async () => {
    try {
      dispatch(userLogout());
      oktaAuth.signOut();
    } catch (e) {}
  };

  //closing okta session when user gets unathenticated error
  useEffect(() => {
    try {
      api.interceptors.response.use(
        (response) => {
          return response;
        },
        (error) => {
          if (error.response && error.response.status === 401) {
            closeOktaSession();
          }
          return Promise.reject(error);
        }
      );
    } catch (e) {}
  }, []);

  if (!authState) {
    return (
      <BasicLayout>
        <Container>
          <div>Loading ... </div>
        </Container>
      </BasicLayout>
    );
  }

  return authState.isAuthenticated ? (
    <Routes>
      <Route path="*" element={<Protected />} />
    </Routes>
  ) : (
    // <Routes>
    //   <Route path="" element={<Protected />} />
    //   <Route path="credit" element={<CreditPage />} />
    //   <Route
    //     path="admin/user-maintenance"
    //     element={userRole === UserRole.ADMIN ? <UserMaintenancePage /> : <></>}
    //   />
    //   <Route
    //     path="admin/servicer-maintenance"
    //     element={
    //       userRole === UserRole.ADMIN ? <ServicerMaintenancePage /> : <></>
    //     }
    //   />
    // </Routes>
    <BasicLayout>
      <Container>
        <OktaSignInWidget
          config={config}
          onSuccess={onSuccess}
          onError={onError}
        />
      </Container>
    </BasicLayout>
  );
};

export default OktaLogin;
